import { observer } from "mobx-react-lite"
import React, { FC, useCallback } from "react"
import { Appearance, TextStyle, View, ViewStyle } from "react-native"
import { Button, DeleteModal, JalaIcon, Screen, Text } from "../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import Icon from 'react-native-vector-icons/MaterialIcons'
import { translate, TxKeyPath } from "../../../i18n"
import { AppStackInitialSync, navigate, resetRoot } from "../../../navigators"
import { color } from "../../../theme"
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useStores } from "../../../models"
import JalaAnalytic from "../../../utils/jala-analytic"


const ROOT: ViewStyle = {
  flex: 1,
}
const FEATURE_CONTAINER: ViewStyle = {
  marginHorizontal: 16,
  borderBottomWidth: 1,
  borderColor: color.palette.gray200,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
}

const LEFT_CONTAINER: ViewStyle = {
  paddingVertical: 14,
  flexDirection: 'row'
}

const LEFT_ICON: ViewStyle =  {
  marginRight: 13
}

const FEATURE_TITLE: TextStyle = {
  fontFamily: 'Lato',
  // color: color.palette.gray800
}

const Item = ({icon, colorScheme, title}: {icon?: string, colorScheme?: "light" | "dark", title?: TxKeyPath}) => {
  return (
    <>
    <View style={LEFT_CONTAINER}>
      {icon === "database-refresh" ?
        <>
          <MaterialCommunityIcon
            name="database-refresh"
            size={20}
            color={color.palette.gray800}
            style={LEFT_ICON}
          />
          <Text tx={title} preset="body2" colorScheme={colorScheme} />
        </>
      :
        <>
          <JalaIcon name={icon} size={20} color={colorScheme === 'light' ? color.palette.gray800 : color.palette.white} style={LEFT_ICON} />
          <Text preset="body2" tx={title} style={FEATURE_TITLE} colorScheme={colorScheme} />
        </>
      }
    </View>
    <View>
        <Icon name="keyboard-arrow-right" size={25} />
    </View>
    </>
  )
}

export const SettingAccountScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function SettingAccountScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  const { appStore } = useStores()

  const onNavigate = (param: string) => () => {
    if (param === "change") {
      JalaAnalytic.log('Mobile app: account - edit password');
      navigate("Profile.Stack", "Profile.Change.Setting.Account.Password")
    }
    else {
      JalaAnalytic.log('Mobile app: account - delete account');
      navigate("Proifle.Stack", "Profile.Change.Setting.Account.Delete")
    }
  }

  const resetOfflineDatabase = useCallback(() => {
    return appStore.removeDatabase()
      .then(() => resetRoot(AppStackInitialSync));
  }, [appStore])

  const Feature = useCallback((
    { title, icon, onPress } :
    { title?: TxKeyPath, icon?:string, onPress?: () => void }
    ) => (
    <Button testID={`jala:id/${icon}-button`} style={FEATURE_CONTAINER} colorScheme={colorScheme} onPress={onPress} preset="link">
      <Item icon={icon} title={title} colorScheme={colorScheme}  />
    </Button>
  ),[colorScheme])

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar="light-content"
      >
      <DeleteModal
        testID="jala:id/delete-button"
        onConfirm={resetOfflineDatabase}
        style={FEATURE_CONTAINER}
        // deleteModalTitle={deleteModalTitle}
        deleteModalSubtitle={translate("settingAccount.resetOfflineDatabaseWarn")}
        colorTitle={color.primaryDarker}
      >
        <Item title="settingAccount.resetOfflineDatabase" icon="database-refresh" colorScheme={colorScheme} />
      </DeleteModal>
      <Feature title="settingAccount.changePassword" icon="key" onPress={onNavigate("change")}  />
      <Feature title="settingAccount.delete" icon="trash" onPress={onNavigate("delete")}  />
    </Screen>
  )
})

